const KEY = 'portal:loginFailureMessage';

export function stashLoginFailure(message: string): void {
  try {
    sessionStorage.setItem(KEY, message);
  } catch {
    // sessionStorage can throw in private-mode Safari — silent no-op is fine
    // because the fallback (reload with no message) is still acceptable UX.
  }
}

export function consumeLoginFailure(): string | null {
  try {
    const message = sessionStorage.getItem(KEY);
    if (message) sessionStorage.removeItem(KEY);
    return message;
  } catch {
    return null;
  }
}
